import { render, staticRenderFns } from "./product.vue?vue&type=template&id=3622e7bf&scoped=true"
import script from "./product.vue?vue&type=script&lang=js"
export * from "./product.vue?vue&type=script&lang=js"
import style0 from "./product.vue?vue&type=style&index=0&id=3622e7bf&prod&scoped=true&lang=css"
import style1 from "./product.vue?vue&type=style&index=1&id=3622e7bf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_f33b182414a87044fb4ff91041025cb4/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3622e7bf",
  null
  
)

export default component.exports